import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import brandHeroWithBlocks from '../../../images/brandhero/brandhero_with_blocks.gif';
import { FlotiqLogo } from '../../../images/shapes';

interface PopulateSpaceModalLoadingProps {
  testId?: string;
}

export const PopulateSpaceModalLoading = ({
  testId,
}: PopulateSpaceModalLoadingProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col gap-2 justify-center"
      {...getTestProps(testId, 'loader-container')}
    >
      <div>
        <FlotiqLogo className="h-8" />
      </div>
      <img
        src={brandHeroWithBlocks}
        alt="flotiq loader"
        className="mx-auto mb-6 h-60"
      />
      <span
        className={
          'text-slate-900 whitespace-pre-line text-center dark:text-white' +
          ' font-bold text-3xl/[32px] mb-3 md:text-4xl/[36px]'
        }
      >
        {t('PopulateSpaceModal.ModalLoader.Header')}
      </span>
    </div>
  );
};

export default PopulateSpaceModalLoading;
